import { Check, TriangleAlert } from 'lucide-react';

/** A control reading from outside-in signals or a connector, set against the assessment's answer. */
export interface Reading {
  control: string;
  implementation: number;
  reason: string;
  question: string | null;
  suggests: { value: string; label: string } | null;
  answer: { value: unknown; provenance: string } | null;
  agrees: boolean | null;
}

const said = (p: string) => p.toLowerCase().replace(/_/g, ' ');

/** Each reading, whether the answer agrees, and (for staff) a button to record it as the answer. */
export function ReadingList({
  readings,
  onAccept,
  busy,
}: {
  readings: Reading[];
  onAccept?: (control: string) => void;
  busy?: boolean;
}) {
  // prettier-ignore
  return (
    <ul className="oi-readings">
      {readings.map((r) => (
        <li key={r.control}>
          <div>
            <span className="mono small">{r.control}</span> {r.agrees === false && <TriangleAlert size={13} className="warn-t" aria-label="Contradicts the answer" />}
            <div className="small">{r.reason}</div>
            <div className="muted small">
              {r.suggests ? `Reads as “${r.suggests.label}”` : 'No question takes this reading'}
              {r.answer ? ` · answered “${String(r.answer.value)}” (${said(r.answer.provenance)})` : ' · not answered'}
            </div>
          </div>
          {r.agrees ? (
            <Check size={15} className="ok-t" aria-label="Matches the answer" />
          ) : (
            onAccept && r.suggests && (
              <button type="button" className="btn btn-sm" disabled={busy} onClick={() => onAccept(r.control)}>
                Accept
              </button>
            )
          )}
        </li>
      ))}
    </ul>
  ); // prettier-ignore
}
